import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function Projects() {
  return (
    <div className="max-w-2xl mx-auto mt-16">
      <div className="panel-elev tick-brackets p-10 text-center" data-testid="projects-private-notice">
        <Lock className="w-6 h-6 text-[#C9A961] mx-auto mb-4" />
        <div className="font-tech mb-3">Private Project Registry</div>
        <h1 className="text-2xl font-semibold text-white">Submitted projects are private</h1>
        <p className="text-slate-400 mt-4 text-sm leading-relaxed">
          A.I.U.D.E. does not display submitted visitor projects in a public directory.
          Each project remains reachable only through the unguessable link returned when it was created,
          or through the administrator console.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mt-8">
          <Link to="/intake" className="btn-primary text-sm" data-testid="projects-cta-new">Start a New Design Project</Link>
          <Link to="/admin/login" className="btn-ghost text-sm" data-testid="projects-cta-admin">Administrator Sign In</Link>
        </div>
      </div>
    </div>
  );
}
